import React from "react";
import { Modal, Alert, Space } from "antd";
import { ReloadOutlined } from "@ant-design/icons";

interface ContainerResetModalProps {
  visible: boolean;
  loading: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const ContainerResetModal: React.FC<ContainerResetModalProps> = ({
  visible,
  loading,
  onClose,
  onConfirm,
}) => {
  return (
    <Modal
      className="mobile-modal compact-modal"
      title={
        <Space>
          <ReloadOutlined style={{ color: "#ff4d4f" }} />
          Reset Container
        </Space>
      }
      open={visible}
      onCancel={onClose}
      onOk={onConfirm}
      confirmLoading={loading}
      okText="Yes, Reset"
      okButtonProps={{ danger: true }}
      cancelText="Cancel"
      width="100%"
      centered
    >
      <Alert
        message="⚠️ Reset Container?"
        description={
          <div style={{ fontSize: "13px" }}>
            <p style={{ margin: "4px 0 8px 0" }}>
              This will reset all unloading data:
            </p>
            <div style={{ fontSize: "12px", lineHeight: "1.6", marginLeft: 8 }}>
              • Container status → "Not Started"
              <br />
              • All carton counts → Cleared
              <br />
              • Pallet info → Removed
              <br />• Delivery setup → Deleted
            </div>
            <p
              style={{
                marginTop: 8,
                marginBottom: 0,
                fontWeight: "600",
                color: "#ff4d4f",
                fontSize: "12px",
              }}
            >
              ⚠️ Cannot be undone!
            </p>
          </div>
        }
        type="warning"
        showIcon
      />
    </Modal>
  );
};
